import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import ContentSlides from '../contentSlides';
import Tab from '../tabInfo';
import RightGroup from '../rightGroup';
import RightBanner from '../rightBanner';

/**
 * 定义 Footer 组件
 */
class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        console.log('content', content);

        return (
            <div className={styles.content}>
                <div className={styles.leftContent}>
                    {/* <Chip id="255127" type="recommend" title="轮播图" groupName="理财首页" content={content.slides}>
                        <ContentSlides />
                    </Chip> */}
                    <Tab content={content} />
                </div>
                <div className={styles.rightContent}>
                    {/* <div className={styles.news_group}>
                        <Chip
                            id="170044"
                            type="struct"
                            title="投资观察"
                            groupName="右侧列表"
                            content={content.investBanner}>
                            <RightBanner />
                        </Chip>
                        <Chip
                            id="195042"
                            type="recommend"
                            title="投资观察信息"
                            groupName="右侧列表"
                            content={content.investInfo}>
                            <RightGroup />
                        </Chip>
                    </div> */}
                    <div className={styles.news_group}>
                        <Chip
                            id="170045"
                            type="struct"
                            title="银行观察"
                            groupName="右侧列表"
                            content={content.bankBanner}>
                            <RightBanner />
                        </Chip>
                        {content.bankInfo.length > 0 ? <RightGroup content={content.bankInfo} /> : ''}
                    </div>
                    <div className={styles.news_group}>
                        <Chip
                            id="200045"
                            type="struct"
                            title="基金观察"
                            groupName="右侧列表"
                            content={content.fundBanner}>
                            <RightBanner />
                        </Chip>
                        {content.fundInfo.length > 0 ? <RightGroup content={content.fundInfo} /> : ''}
                    </div>
                    <div className={styles.news_group}>
                        <Chip
                            id="170046"
                            type="struct"
                            title="保险观察"
                            groupName="右侧列表"
                            content={content.insureBanner}>
                            <RightBanner />
                        </Chip>
                        {content.insureInfo.length > 0 ? <RightGroup content={content.insureInfo} /> : ''}
                    </div>
                    <div className={styles.adAside} key="asideAd">
                        <Ad content={content.asideAd} />
                    </div>
                </div>
            </div>
        );
        // return footer;
    }
}

export default errorBoundary(Content);
